import { ImmutableMap, Prop, QueryParams, RequiredOnly, isObject, isString } from '@daikin-tic/dxone-com-lib';

type DeviceSetRequiredProps = {
  name: string;
  organizationId: string;
};

type DeviceSetOptionalProps = object;

type DeviceSetProvidedProps = {
  deviceSetId: string;
  updatedAt: number;
  version: number;
};

export type DeviceSetQueryParams = QueryParams;

export type DeviceSetCreateParams = DeviceSetRequiredProps & DeviceSetOptionalProps;

export type DeviceSet = DeviceSetRequiredProps & DeviceSetOptionalProps & DeviceSetProvidedProps;

export function isDeviceSetCreateParams(value: unknown): value is DeviceSetCreateParams {
  const sProps: Prop<RequiredOnly<DeviceSetCreateParams>, string>[] = ['name', 'organizationId'];
  return isObject(value) && sProps.every(prop => isString(value[prop]));
}

export class DeviceSets extends ImmutableMap<string, DeviceSet> {
  constructor(deviceSets?: DeviceSet[] | Iterable<DeviceSet>) {
    super((deviceSet: DeviceSet) => deviceSet.deviceSetId, deviceSets);
  }

  protected clone(deviceSets?: DeviceSet[] | Iterable<DeviceSet>): this {
    return new DeviceSets(deviceSets) as this;
  }
}
